import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./About.css";
import AboutCard from "./AboutDetails.js";
import TechTools from "./TechTools.js";
import Tools from "./Tools.js";
import Github from "./GitHubCalender";
import profileImage from "../../components/profile.jpeg";
import { education, profile } from "../../data/portfolio";

const About = () => {
  return (
    <Container fluid className="about-section section-shell">
      <Container>
        <Row className="g-5 align-items-center">
          <Col lg={7}>
            <AboutCard />
          </Col>
          <Col lg={5}>
            <div className="about-profile-card scroll-reveal">
              <img src={profileImage} alt={profile.name} className="about-profile-image" />
              <div>
                <h2>{profile.name}</h2>
                <p>{profile.role}</p>
                <div className="about-education">
                  <span>{education.degree}</span>
                  <strong>{education.school}</strong>
                  <small>
                    {education.period} · CGPA {education.cgpa}
                  </small>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="skill-section scroll-reveal">
          <div className="section-kicker">Capabilities</div>
          <h2 className="section-title">Frontend, mobile, testing, and delivery tooling.</h2>
          <TechTools />
          <Tools />
        </div>

        <div className="github-panel glass-panel scroll-reveal">
          <Github />
        </div>
      </Container>
    </Container>
  );
};

export default About;
